import { createSlice } from "@reduxjs/toolkit";
import { getReferralRules } from "./thunk";
import { PaginationResponse, ResponseData } from "api/types/_public";
import { IOperator } from "api/types/_operator";


export interface IState {
  rules: ResponseData<IOperator[]> & PaginationResponse | null,
  isRuleLoading: boolean,
  isRuleSuccess: boolean,

  error: any,
};

export const initialState: IState = {
  rules: null,
  isRuleLoading: false,
  isRuleSuccess: false,

  error: {},
};

const RuleSlice = createSlice({
  name: "Rule",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get rules
    builder.addCase(getReferralRules.pending, (state: IState, action: any) => {
      state.isRuleLoading = true
    });
    builder.addCase(getReferralRules.fulfilled, (state: IState, action: any) => {
      state.rules = action.payload.data;
      state.isRuleSuccess = true;
      state.isRuleLoading = false;
    });
    builder.addCase(getReferralRules.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isRuleSuccess = false;
      state.isRuleLoading = false;
    });
  },
});

export default RuleSlice.reducer;
